import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const WhatsAppButton = ({ phoneNumber, message = 'Halo, saya ingin bertanya' }) => {
  const location = useLocation();
  const path = location.pathname;

  // Hide button on live auction and time bid pages
  const hiddenPaths = ['/live-auction', '/time-auction'];
  if (hiddenPaths.some(hiddenPath => path.includes(hiddenPath))) {
    return null;
  }

  const handleClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 bg-[#25D366] hover:bg-[#20BA56] text-white rounded-full p-4 shadow-lg transition-all duration-300 z-50 flex items-center justify-center"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className="text-2xl" />
    </button>
  );
};

WhatsAppButton.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  message: PropTypes.string
};

export default WhatsAppButton; 